import { Box, Flex} from "@chakra-ui/react";
import { GhanaLotto } from "../components/lotto/GhanaLotto";
import { Bonanza5 } from "../components/lotto/Bonanza5";
import { useReducer, useState, useMemo, useEffect } from "react";
import useBonanza5 from "../hooks/useBonanza5";
import useGhanaLotto from "../hooks/useGhanaLotto";
import { calculateSummary } from "../utils/calculateSummary";


const initialState = {
    ghanaLotto: {
        data: null,
        loading: false,
        error: null,
    },
    bonanza5: {
        data: null,
        loading: false,
        error: null,
    },
}


const reducer = (state, action) => {
    switch (action.type) {
        case 'setLoading':
            return {
                ...state,
                [action.payload.target]: {
                    ...state[action.payload.target],
                    loading: action.payload.loading,
                },
            };
        case 'setData':
            return {
                ...state,
                [action.payload.target]: {
                    ...state[action.payload.target],
                    data: action.payload.data,
                },
            };
        case 'setError':
            return {
                ...state,
                [action.payload.target]: {
                    ...state[action.payload.target],
                    error: action.payload.error,
                },
            };
        default:
            return state;
    }
}


const Trends = () => {  
    console.log('Rendering Trends')
    const [activeGame, setActiveGame] = useState("ghanaLotto")
    const [state, dispatch] = useReducer(reducer, initialState)

    const totalData = 120
    useGhanaLotto(dispatch, totalData)
    useBonanza5(dispatch, totalData)

    const ghanaLottoDataSummary = useMemo(() => {
        if (state.ghanaLotto.data) return calculateSummary(state.ghanaLotto.data)
    }, [state.ghanaLotto.data])

    const bonanza5DataSummary = useMemo(() => {
        if (state.bonanza5.data) return calculateSummary(state.bonanza5.data)
    }, [state.bonanza5.data])

    return ( 
        <Box 
            id="trends_page"
            width="100vw"
            height="100vh"
        >
            <Box className="container"
                margin="0 auto"
                width={{base:"98%", md:"80%"}} 
                height="100%" 
                fontSize={{base:"0.8rem", md:"1rem"}}
            >
                <Flex className="game_tab_toggles" padding="30px 0 20px" justify="center">
                    <GameButton onClick={() => setActiveGame('ghanaLotto')} isActive={activeGame === "ghanaLotto"}>Ghana Lotto</GameButton>
                    <GameButton onClick={() => setActiveGame('bonanza5')} isActive={activeGame === "bonanza5"}>Bonanza 5</GameButton>
                </Flex>

                <Box className="active_game_tab">
                    {activeGame === 'ghanaLotto' && <GhanaLotto dataList={state.ghanaLotto.data} summary={ghanaLottoDataSummary} loading={state.ghanaLotto.loading} error={state.ghanaLotto.error}/>}
                    {activeGame === 'bonanza5' && <Bonanza5 dataList={state.bonanza5.data} summary={bonanza5DataSummary} loading={state.bonanza5.loading} error={state.bonanza5.error}/>}        
                </Box>
            </Box>
        </Box>
    )
}

export default Trends





const GameButton = ({children, isActive, ...props}) => {
    const [isHovered, setIsHovered] = useState(false)

    return (
        <Box
            padding="5px 10px"
            cursor= "pointer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            bg={isActive ? "lightgreen" : ""}
            color={isActive ? "black" : isHovered ? {base:"", md:"lightgreen"} : ""}
            borderRadius = "20px"
            {...props}
        >
            {children}
        </Box>
    )
}







